import React, { Component } from 'react';

import IconHide from '../../assets/icons/IconHide';

class HideButton extends Component {
    render() {
        return (
            <button type="button" id="btnhide" className="flex flex-end items-center bg-white rounded p-1 focus:outline-none">
                <IconHide />
                <span className="text-sm p-0.5 ml-2">Sembunyikan</span>
            </button>
        );
    }
}

export default HideButton;